// extracted by mini-css-extract-plugin
export default {"dropdownsContainer":"Dropdowns_dropdownsContainer__77b0v"};